module.exports = __webpack_public_path__ + "static/media/Major Project ETRX 2019-20.c68754d3.pdf";